exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes glowing{0%{box-shadow:0 0 -10px #82a683;transform:scale(1)}40%{box-shadow:0 0 20px #82a683;transform:scale(1.1)}60%{box-shadow:0 0 20px #82a683;transform:scale(1.1)}to{box-shadow:0 0 -10px #82a683;transform:scale(1)}}.input-glow{animation:glowing 1.5s 1}.smallDisplay .container{max-width:100vw!important}.v-dialog:not(.v-dialog--fullscreen){max-height:90%}", ""]);

// exports
